import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SupportIcon } from '@emburse/embark-icons';
import { Grid, Icon, Tooltip, Typography } from '@emburse/embark-core';
function Title({ children, helpText, helpTextStyle, variant }) {
    return (_jsxs(Grid, { container: true, direction: helpTextStyle === 'tooltip' ? 'row' : 'column', style: {
            columnGap: 5,
            alignItems: helpTextStyle === 'tooltip' ? 'center' : 'initial'
        }, children: [_jsx(Grid, { item: true, children: _jsx(Typography, { variant: variant, display: helpTextStyle === 'tooltip' ? 'inline' : 'block', children: children }) }), _jsxs(Grid, { item: true, children: [helpTextStyle === 'tooltip' && (_jsx(Tooltip, { title: helpText, children: _jsx(Icon, { iconUrl: SupportIcon }) })), helpTextStyle === 'inline' && (_jsx(Typography, { variant: "caption", children: helpText }))] })] }));
}
Title.defaultProps = {
    children: '',
    helpTextStyle: 'inline',
    variant: 'h6'
};
export default Title;
